import React from 'react';
import "./DoorSensor.css";
import DoorSensorTable from "./DoorSensorTable.tsx";
import openDoorFilled from "../../../assets/doorOpenFilled.svg";
import closeDoorFilled from "../../../assets/doorClosedFilled.svg"
import openDoorSolid from "../../../assets/doorOpenSolid.svg";
import closeDoorSolid from "../../../assets/doorClosedSolid.svg"
import doorSensorIcon from "../../../assets/blackDoorIcon.svg";
import sensorIcon from "../../../assets/sensorIcon.svg";

const DoorSensor = () =>{
    return (
        <div className='apiGatewayMainContainer'>
            {/* <p>Door Sensor</p> */}
            <div className='dashboardDoorSensortopContainer' style={{ marginBottom:"5px" }}>
                <div className='doorSensorIconDiv'>
                    <span><img className='SensorIcon' src={sensorIcon} alt="SensorIcon" style={{display:"none"}}/></span>
                    <span><img className='doorSensorImg' src={doorSensorIcon} alt="doorSensorIcon" /></span>
                </div>
                <p className='DoorSensorHeading' style={{ marginBottom: "5px"}}>Door Sensor</p>
            </div>
         <DoorSensorTable />
        </div>
    )
}

export default DoorSensor;


